module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Сумма":"Amount","Всего":"Total","Комиссия":"Commission"}}')
  delete Component.options._Ctor
}
